import DynamicFeedbackInputFields from './DynamicFeedbackFields/DynamicFeedbackInputFields';

const TeacherFeedback = () => {

    const teacherFields = [
        { fieldName: 'name', customLabelName: "Name:", type: 'text', placeholder: 'Enter Your Name' },
        { fieldName: 'department', customLabelName: "Department:", type: 'text', placeholder: 'Enter Your Department' },
        { fieldName: 'email', customLabelName: "Email Address:", type: 'email', placeholder: 'Enter Your Email' },
        { fieldName: 'designation', customLabelName: "Designation:", type: 'text', placeholder: 'Enter Your Designation' },
        { fieldName: 'feedback', customLabelName: "Feedback:", type: 'textarea', placeholder: 'Enter Your Feedback' }
    ];

    return (
        <DynamicFeedbackInputFields
            title="Staff's Feedback"
            fields={teacherFields}
            formType="teachers"
        />
    )
}

export default TeacherFeedback
